import getTheme from 'config/themes/base';

const theme = getTheme();

export default {
  cropContainer: {
    position: 'relative',
    width: '100%',
    height: 448,
    background: '#333',
    [theme.breakpoints.up('sm')]: {
      height: 600,
    },
    mb: 2,
  },
  controls: {
    padding: '8px 0',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    width: '100%',
    boxSizing: 'border-box',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    overflow: 'hidden',
  },
  sliderContainer: {
    display: 'flex',
    flex: '1',
    alignItems: 'center',
    minWidth: 0,
  },
  sliderLabel: {
    [theme.breakpoints.down('xs')]: {
      minWidth: 60,
    },
  },
  slider: {
    padding: '22px 0px',
    marginLeft: 32,
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      alignItems: 'center',
      margin: '0 16px',
    },
  },
  buttonGroup: {
    display: 'flex',
  },
  button: {
    marginLeft: '8px',
    padding: '5px 16px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    backgroundColor: '#fff',
    transition: 'background-color 0.3s',
    '&:hover': {
      backgroundColor: '#1a5787',
      color: '#fff',
    },
  },
  selectedButton: {
    backgroundColor: '#1a5787',
    color: '#fff',
  },
};
